import { about } from './about';
import { availability } from './availability';
import { barcode } from './barcode';
import { category } from './category';
import { collections } from './collections';
import { condition } from './condition';
import { countryCode } from './countryCode';
import { description } from './description';
import { files } from './files';
import { hsCode } from './hsCode';
import { itemLocation } from './itemLocation';
import { itemSpecifics } from './itemSpecifics';
import { materials } from './materials';
import { metaDescription } from './metaDescription';
import { pageTitle } from './pageTitle';
import { personalization } from './personalization';
import { photos } from './photos';
import { price } from './price';
import { processingProfile } from './processingProfile';
import { productType } from './productType';
import { productionPartners } from './productionPartners';
import { quantity } from './quantity';
import { section } from './section';
import { sellingMethod } from './sellingMethod';
import { shipping } from './shipping';
import { shippingDimensions } from './shippingDimensions';
import { shippingWeight } from './shippingWeight';
import { sku } from './sku';
import { gtin } from './gtin';
import { tags } from './tags';
import { tariffCode } from './tariffCode';
import { taxonomyAttributes } from './taxonomyAttributes';
import { title } from './title';
import { variations } from './variations';
import { vendor } from './vendor';
import { videos } from './videos';
import { weight } from './weight';
import { getSize } from '../../../iterable/getSize';

import { EBAY, ETSY } from '../../../../constants/channels';
import { ATTRIBUTE } from '../../../../constants/attributes';
import { MENU_ITEM } from '../../../../constants/bulkEdit';

export function applyPreviewOperations({ bulkEdit, userFeatures }) {
  const preview = bulkEdit.get('preview');

  if (getSize(preview) === 0) {
    return {};
  }

  const channel = bulkEdit.get('channel');
  const shopId = bulkEdit.get('shopId');
  const selectedMenuItem = bulkEdit.getIn(['menu', 'selected', 'item']);
  const operation = bulkEdit.getIn(['menu', 'operation']);

  switch (selectedMenuItem) {
    case MENU_ITEM.ABOUT: {
      return about({ preview });
    }

    case MENU_ITEM.AVAILABILITY: {
      return availability({ preview });
    }

    case MENU_ITEM.BARCODE: {
      return barcode({ channel, operation, preview });
    }

    case MENU_ITEM.BODY_HTML:
    case MENU_ITEM.DESCRIPTION: {
      return description({ channel, operation, preview, state: bulkEdit, userFeatures });
    }

    case MENU_ITEM.CAP:
    case MENU_ITEM.CPI:
    case MENU_ITEM.PRICE: {
      return price({ channel, preview });
    }

    case MENU_ITEM.CATEGORY:
    case MENU_ITEM.ITEM_CATEGORY:
    case MENU_ITEM.STORE_CATEGORY: {
      return category({ channel, preview });
    }

    case MENU_ITEM.COLLECTIONS: {
      return collections({ channel, preview });
    }

    case MENU_ITEM.CONDITION: {
      return condition({ preview });
    }

    case MENU_ITEM.COUNTRY_CODE: {
      return countryCode({ preview });
    }

    case MENU_ITEM.FILES: {
      return files({ channel, operation, preview });
    }

    case MENU_ITEM.GTIN: {
      return gtin({ channel, preview });
    }

    case MENU_ITEM.HS_CODE: {
      return hsCode({ preview });
    }

    case MENU_ITEM.ITEM_SIZE: {
      return shippingDimensions({ channel, preview });
    }

    case MENU_ITEM.ITEM_WEIGHT: {
      return shippingWeight({ channel, preview });
    }

    case MENU_ITEM.ITEM_LOCATION: {
      return itemLocation({ channel, preview });
    }

    case MENU_ITEM.MATERIALS: {
      return materials({ channel, preview });
    }

    case MENU_ITEM.META_DESCRIPTION: {
      return metaDescription({ channel, operation, preview, state: bulkEdit });
    }

    case MENU_ITEM.PAGE_TITLE: {
      return pageTitle({ channel, operation, preview, state: bulkEdit });
    }

    case MENU_ITEM.PAYMENT_POLICY: {
      return shipping({ attribute: ATTRIBUTE.PAYMENT_POLICY, preview });
    }

    case MENU_ITEM.PERSONALIZATION: {
      return personalization({ channel, operation, preview });
    }

    case MENU_ITEM.PHOTOS: {
      return photos({ channel, operation, preview, state: bulkEdit });
    }

    case MENU_ITEM.PROCESSING_PROFILE: {
      return processingProfile({ preview });
    }

    case MENU_ITEM.PRODUCT_TYPE: {
      return productType({ channel, preview, shopId });
    }

    case MENU_ITEM.PRODUCTION_PARTNER: {
      return productionPartners({ channel, preview });
    }

    case MENU_ITEM.QUANTITY: {
      return quantity({ channel, preview });
    }

    case MENU_ITEM.RETURN_POLICY: {
      return shipping({ attribute: ATTRIBUTE.RETURN_POLICY, preview });
    }

    case MENU_ITEM.SECTION: {
      return section({ channel, preview, shopId });
    }

    case MENU_ITEM.SELLING_METHOD: {
      return sellingMethod({ bulkEdit, channel, preview });
    }

    case MENU_ITEM.SHIPPING_POLICY: {
      return shipping({ attribute: ATTRIBUTE.SHIPPING_POLICY, preview });
    }

    case MENU_ITEM.SHIPPING_PROFILE: {
      return shipping({ attribute: ATTRIBUTE.PROFILE_ID, preview });
    }

    case MENU_ITEM.SKU: {
      return sku({ channel, preview });
    }

    case MENU_ITEM.TAGS: {
      return tags({ channel, operation, preview, state: bulkEdit, userFeatures });
    }

    case MENU_ITEM.TARIFF_CODE: {
      return tariffCode({ preview });
    }

    case MENU_ITEM.TITLE: {
      return title({ channel, operation, preview, state: bulkEdit, userFeatures });
    }

    case MENU_ITEM.VARIATIONS: {
      return variations({ channel, preview });
    }

    case MENU_ITEM.VENDOR: {
      return vendor({ channel, preview, shopId });
    }

    case MENU_ITEM.VIDEOS: {
      return videos({ channel, operation, preview });
    }

    case MENU_ITEM.WEIGHT: {
      return weight({ preview });
    }

    default: {
      if (bulkEdit.getIn(['menu', 'items', selectedMenuItem, 'isTaxonomy'])) {
        switch (channel) {
          case EBAY: {
            return itemSpecifics({
              preview,
              property: bulkEdit.getIn(['menu', 'items', selectedMenuItem]),
            });
          }

          case ETSY: {
            return taxonomyAttributes({
              attribute: bulkEdit.getIn(['menu', 'items', selectedMenuItem]),
              channel,
              preview,
            });
          }

          default: {
            return {};
          }
        }
      }

      return {};
    }
  }
}
